// src/services/events.ts
import api, { webApi, getCsrfToken } from "../api";

export function getEvents() {
  return api.get("/events");
}

export function getEvent(id: string) {
  return api.get(`/events/${id}`);
}

export async function createEvent(payload: any) {
  await getCsrfToken();
  return webApi.post(`/admin/events`, payload);
}

export async function updateEvent(id: string | number, payload: any) {
  await getCsrfToken();
  try {
    // include id in body so defensive server handlers can locate the record
    return await webApi.put(`/admin/events/${id}`, { id, ...payload });
  } catch (err: any) {
    if (err?.response?.status === 405 || err?.response?.status === 404) {
      try {
        return await webApi.put(`/admin/events?id=${id}`, payload);
      } catch (e: any) {
        return webApi.put(`/admin/events`, { id, ...payload });
      }
    }
    throw err;
  }
}

export async function deleteEvent(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/events/${id}`);
}

export async function toggleAttendance(
  eventId: string | number,
  rsvpId: string | number
) {
  // Ensure CSRF cookie is available for sanctum-protected API
  await getCsrfToken();
  return api.post(`/admin/events/${eventId}/attendance/${rsvpId}`);
}

// User RSVP for an event (client-side helper). Backend should accept POST /events/:id/rsvp
export async function rsvpEvent(
  eventId: string | number,
  status: "going" | "maybe" = "going"
) {
  await getCsrfToken();
  try {
    // send a status (backend requires 'status' in request)
    return await webApi.post(`/events/${eventId}/rsvp`, { status });
  } catch (err: any) {
    // fallback to api endpoint if webApi fails
    return await api.post(`/events/${eventId}/rsvp`, { status });
  }
}

// Cancel a user's RSVP for an event
export async function cancelRsvpEvent(eventId: string | number) {
  await getCsrfToken();
  try {
    return await webApi.delete(`/events/${eventId}/rsvp`);
  } catch (err: any) {
    return await api.delete(`/events/${eventId}/rsvp`);
  }
}
